const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/delivery-details/deliveryDetails.vue2.js
// module id = 821
// module chunks = 41